// YouTube search URL builder for exercises.
//
// Strategy: ONLY use the exact exercise name. Adding channel prefixes
// (Jeff Nippard / Athlean-X / etc.) drags YouTube's relevance away from
// the actual movement when that channel hasn't covered the variant
// (e.g. "Bicycle Crunch" → channel prefix returns generic crunch content).
//
// We just append "exercise how to" so YouTube ranks tutorial-style
// videos above shorts, music covers, and unrelated content.

const VIDEOS_ONLY = '&sp=EgIQAQ%253D%253D'; // YouTube filter: Videos only

/**
 * Returns a YouTube search URL whose first results are very likely to be
 * tutorial videos of the exact named exercise.
 */
export const youtubeVideoUrl = (exerciseName) => {
  const name = String(exerciseName || '').trim();
  if (!name) return 'https://www.youtube.com';
  const query = `${name} exercise how to`;
  return `https://www.youtube.com/results?search_query=${encodeURIComponent(query)}${VIDEOS_ONLY}`;
};

/** Kept for back-compat with callers that show a "curated" badge — always false now. */
export const hasCuratedVideo = () => false;
